// Create temporary preview URL
export const getFilePreview = (file) => {
  return URL.createObjectURL(file);
};

// Formats file size, auto determines units
export const formatFileSize = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

  return `${size} ${sizes[i]}`;
};

// downloads and stores image in memeory as blob from presigned url
export async function fetchImageAsBlobUrl(url) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch image: ${response.statusText}`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  return objectUrl;
}

export function cleanUpMediaUrls(previousBlobUrls) {
  previousBlobUrls.forEach((url) => URL.revokeObjectURL(url));
  return [];
}

export const EXTENSION_TO_MIME = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  webp: "image/webp",
  svg: "image/svg+xml",

  mp4: "video/mp4",
  webm: "video/webm",

  pdf: "application/pdf",

  txt: "text/plain",
  csv: "text/csv",

  mp3: "audio/mpeg",
  wav: "audio/wav",
};
